import { AbilityCan, AbilitySubjects, UserRole } from '../../enums';
import { IAbilityFunction } from '../abilities.types';
import { ICaslCondition } from '../utils';
import { IReleaseNoteCalculatedSubject } from './releaseNoteTypes';

const { CRUD, READ } = AbilityCan;
const { ADMIN, EMPLOYEE, EXTERNAL_RECEIVER, DRIVER } = UserRole;

// forbid argument kept for uniform define ability calls
export function defineAbilitiesForReleaseNotes(_allow: IAbilityFunction, _forbid: IAbilityFunction) {
    type SubjectShape = ICaslCondition<IReleaseNoteCalculatedSubject>;

    const allow = (can: AbilityCan | AbilityCan[], shape: SubjectShape) =>
        _allow(can, AbilitySubjects.RELEASE_NOTE, shape);

    allow(CRUD, { relationRole: ADMIN });
    allow(READ, { relationRole: EMPLOYEE });
    allow(READ, { relationRole: EXTERNAL_RECEIVER });
    allow(READ, { relationRole: DRIVER });
}
